import { useCallback, useEffect, useMemo, useState } from 'react'

import { debounce } from 'lodash'
import { Search, Funnel } from 'lucide-react'
import { Label, FormGroup, Button, Col, DefaultPopover, Input, Row, SelectMulti, Separator } from 'twyne-new.ui'

import { useBuilderStore } from '../../../store'

import { useBlocks } from './hooks'

export default function Filters() {
  return <>
    <div className='flex items-center gap-1'>
      <Term />
      <Filter />
    </div>
    <Separator className='m-0 p-0 my-2' />
  </>
}

function Term() {
  const { filters: { setSearch } } = useBlocks()

  const [value, setValue] = useState('')

  const debouncedChange = useMemo(() => debounce(setSearch, 500), [setSearch])

  const handleChange = useCallback(event => {
    const { value } = event.target
    setValue(value)
    debouncedChange(value)
  }, [debouncedChange])

  return <div className='relative w-full top-0'>
    <Search size='18' className='absolute left-2 top-1/2 -translate-y-1/2' />
    <Input
      placeholder='Search...'
      className='pl-8 border-0 focus:bg-gray-200 focus:dark:bg-gray-1300'
      value={value}
      onChange={handleChange}
    />
  </div>
}

function Filter() {
  const { filters: { setFilters } } = useBlocks()
  const { templateBlock: { fetchBlocksTags } } = useBuilderStore()

  const [options, setOptions] = useState([])
  const [open, setOpen] = useState(false)
  const [tags, setTags] = useState([])

  const loadOptions = useCallback(async () => {
    const tags = await fetchBlocksTags()
    setOptions(tags.map(tag => ({ value: tag, label: tag })))
  }, [fetchBlocksTags])

  useEffect(() => {
    loadOptions()
  }, [loadOptions])

  const handleApply = useCallback(() => {
    const tagsFilter = tags.length ? tags.map(({ value }) => value) : null
    setFilters(filters => ({
      ...filters,
      tags: tagsFilter,
    }))
    setOpen(false)
  }, [tags, setFilters])

  return <DefaultPopover
    triggerProps={{ asChild: true }}
    wrapperProps={{ open, onOpenChange: setOpen }}
    contentProps={{ side: 'bottom', align: 'center', className: 'mt-1 w-70' }}
    trigger={<Button variant='ghost' size='sm' className='m-0 h-8'>
      <Funnel size='16' />
    </Button>}
  >
    <Row>
      <Col size='12'>
        <FormGroup>
          <Label>Tags</Label>
          <SelectMulti value={tags} onChange={setTags} options={options} clearable creatable />
        </FormGroup>
      </Col>
      <Col size='12'>
        <Button block size='sm' color='accent' onClick={handleApply}>Apply</Button>
      </Col>
    </Row>
  </DefaultPopover>
}
